import { DeleteIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Divider,
  Flex,
  Grid,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
} from "@chakra-ui/react";
import TableLoader from "components/common/TableLoader/TableLoader";
import CustomInput from "components/common/customInput/CustomInput";
import { FieldArray } from "formik";
import { FaPlus } from "react-icons/fa";
import {
  authenticateType,
  isActivetrigger,
  triggerActions,
  triggerApprovals,
} from "../utils/constant";
import React from "react";

const TriggerForm = ({
  activePage,
  values,
  setFieldValue,
  isDisabled,
  generateLevels,
}: any) => {
  return (
    <Box display={activePage === 6 ? undefined : "none"} overflow="hidden">
      {/* Add Triggers */}
      <Flex justifyContent="flex-end">
        {values.triggers?.length === 0 && (
          <Tooltip label="Add Triggers" hasArrow placement="left">
            <Button
              onClick={() => {
                setFieldValue("triggers", [
                  ...values.triggers,
                  {
                    approval: triggerApprovals,
                    level: generateLevels(3),
                    isActive: isActivetrigger[0],
                    action: triggerActions[0],
                    method: undefined,
                    authenticate: true,
                    authType: authenticateType[0],
                    userName: "",
                    password: "",
                    token: "",
                  },
                ]);
              }}
              bg="teal.400"
              color="white"
              _hover={{ bg: "teal.500" }}
              isDisabled={isDisabled}
            >
              <FaPlus />
            </Button>
          </Tooltip>
        )}
      </Flex>

      <Box>
        <FieldArray name="triggers">
          {({ remove }) => (
            <Box>
              {values.triggers.map((trigger: any, index: any) => (
                <Box
                  p={5}
                  rounded={8}
                  shadow={"base"}
                  borderWidth={2}
                  mb={4}
                  key={index}
                >
                  <Text
                    textAlign={"end"}
                    color={"teal"}
                    fontSize="sm"
                    fontWeight="bold"
                  >
                    Trigger {index + 1}
                  </Text>
                  <Grid templateColumns={"1fr 1fr 1fr"} gap={4} mb={4}>
                    <Box>
                      <CustomInput
                        label="Approval"
                        type="select"
                        name={`triggers[${index}].approval`}
                        value={trigger.approval}
                        placeholder="Select Approval"
                        options={triggerApprovals}
                        onChange={(e: any) =>
                          setFieldValue(`triggers[${index}].approval`, e)
                        }
                        rest={{ minWidth: "130px" }}
                        disabled={isDisabled}
                        isBoxSelect={true}
                        isMulti
                      />
                    </Box>

                    <Box>
                      <CustomInput
                        type="select"
                        name={`triggers[${index}].level`}
                        value={trigger?.level}
                        placeholder="Select Level"
                        label="Level"
                        options={generateLevels(values.levels)}
                        onChange={(e: any) =>
                          setFieldValue(`triggers[${index}].level`, e)
                        }
                        rest={{ minWidth: "130px" }}
                        disabled={isDisabled}
                        isBoxSelect={true}
                        isMulti
                      />
                    </Box>

                    <Box>
                      <CustomInput
                        type="select"
                        label="Is Active"
                        name={`triggers[${index}].isActive`}
                        value={trigger?.isActive || ""}
                        placeholder="Active Trigger"
                        options={isActivetrigger}
                        onChange={(e) =>
                          setFieldValue(`triggers[${index}].isActive`, e)
                        }
                        rest={{ minWidth: "130px" }}
                        disabled={isDisabled}
                        isBoxSelect={true}
                      />
                    </Box>

                    <Box>
                      <CustomInput
                        type="select"
                        label="Actions"
                        name={`triggers[${index}].action`}
                        value={trigger.action}
                        placeholder="Select Action"
                        options={triggerActions}
                        onChange={(e: any) => {
                          console.log(e);
                          setFieldValue(`triggers[${index}].action`, e);
                          setFieldValue(`triggers[${index}].method`, "");
                        }}
                        rest={{ minWidth: "130px" }}
                        disabled={isDisabled}
                        isBoxSelect={true}
                      />
                    </Box>

                    <Box>
                      {trigger?.action?.value === triggerActions[0].value ? (
                        <CustomInput
                          type="text"
                          label="Method"
                          name={`triggers[${index}].method`}
                          value={trigger.method}
                          placeholder="Please Enter Url"
                          onChange={(e: any) =>
                            setFieldValue(
                              `triggers[${index}].method`,
                              e.target.value
                            )
                          }
                          rest={{ minWidth: "280px" }}
                          disabled={isDisabled}
                        />
                      ) : (
                        <CustomInput
                          type="text"
                          name={`triggers[${index}].method`}
                          value={trigger.method}
                          placeholder="Enter emails (comma-separated)"
                          onChange={(e: any) =>
                            setFieldValue(
                              `triggers[${index}].method`,
                              e.target.value
                            )
                          }
                          rest={{ minWidth: "280px" }}
                          disabled={isDisabled}
                        />
                      )}
                    </Box>
                  </Grid>
                  <Divider borderColor={"gray.300"} my={2} />
                  {values &&
                    values.triggers.some(
                      (trigger: any) => trigger.action.value === "url"
                    ) && (
                      <CustomInput
                        disabled={isDisabled}
                        type="switch"
                        label="Authenticate"
                        name={`triggers[${index}].authenticate`}
                        value={trigger.authenticate}
                        onChange={(e: any) =>
                          setFieldValue(
                            `triggers[${index}].authenticate`,
                            e.target.checked
                          )
                        }
                      />
                    )}
                  <Grid templateColumns={"1fr 1fr 1fr"} gap={4} mt={2}>
                    {values &&
                      values.triggers.some(
                        (trigger: any) =>
                          trigger.action.value === "url" &&
                          trigger.authenticate === true
                      ) && (
                        <CustomInput
                          type="select"
                          name={`triggers[${index}].authType`}
                          label="Authentication Type"
                          value={trigger.authType}
                          placeholder="Select Type"
                          options={authenticateType}
                          onChange={(e: any) => {
                            console.log(e);
                            setFieldValue(`triggers[${index}].authType`, e);
                          }}
                          rest={{ minWidth: "180px" }}
                          disabled={isDisabled}
                          isBoxSelect={true}
                        />
                      )}
                    {values &&
                      values.triggers.some(
                        (trigger: any) =>
                          trigger.action.value === "url" &&
                          trigger.authenticate === true &&
                          trigger.authType.value === "credential"
                      ) && (
                        <>
                          <CustomInput
                            name={`triggers[${index}].userName`}
                            label="Username"
                            value={trigger.userName}
                            onChange={(e: any) =>
                              setFieldValue(
                                `triggers[${index}].userName`,
                                e.target.value
                              )
                            }
                            placeholder="Enter username"
                            disabled={isDisabled}
                            rest={{ minWidth: "180px" }}
                          />
                          <CustomInput
                            name={`triggers[${index}].password`}
                            type="password"
                            label="Password"
                            value={trigger.password}
                            onChange={(e: any) =>
                              setFieldValue(
                                `triggers[${index}].password`,
                                e.target.value
                              )
                            }
                            placeholder="Enter password"
                            disabled={isDisabled}
                            rest={{ minWidth: "180px" }}
                          />
                        </>
                      )}
                    {values &&
                      values.triggers.some(
                        (trigger: any) =>
                          trigger.action.value === "url" &&
                          trigger.authenticate === true &&
                          trigger.authType.value === "jwt"
                      ) && (
                        <CustomInput
                          name={`triggers[${index}].token`}
                          value={trigger.token}
                          onChange={(e: any) =>
                            setFieldValue(
                              `triggers[${index}].token`,
                              e.target.value
                            )
                          }
                          placeholder="Enter token"
                          disabled={isDisabled}
                          rest={{ minWidth: "180px" }}
                        />
                      )}
                  </Grid>

                  <Flex justify={"end"}>
                    <Tooltip label="Delete trigger" hasArrow placement="left">
                      <Button
                        type="button"
                        mt="8px"
                        colorScheme="red"
                        variant="outline"
                        size="sm"
                        onClick={() => remove(index)}
                        h="38px"
                        isDisabled={isDisabled}
                      >
                        <DeleteIcon />
                      </Button>
                    </Tooltip>
                    {index === values.triggers.length - 1 && (
                      <Tooltip label="Add trigger" hasArrow placement="left">
                        <Button
                          bg="teal.400"
                          size={"sm"}
                          color="white"
                          _hover={{ bg: "teal.500" }}
                          ml={3}
                          h="38px"
                          mt="8px"
                          onClick={() => {
                            setFieldValue("triggers", [
                              ...values.triggers,
                              {
                                approval: triggerApprovals,
                                level: generateLevels(3),
                                isActive: isActivetrigger[0],
                                action: triggerActions[0],
                                method: undefined,
                                authenticate: true,
                                authType: authenticateType[0],
                                userName: "",
                                password: "",
                                token: "",
                              },
                            ]);
                          }}
                          isDisabled={isDisabled}
                        >
                          <FaPlus />
                        </Button>
                      </Tooltip>
                    )}
                  </Flex>
                </Box>
              ))}
            </Box>
          )}
        </FieldArray>
      </Box>

      {/* <Box
        mt={3}
        overflowY="auto"
        className="customScrollBar"
        w={{ base: "70vw", md: "78vw", lg: "77vw" }}
      >
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th whiteSpace="nowrap">Approvals</Th>
              <Th whiteSpace="nowrap">Level</Th>
              <Th whiteSpace="nowrap">Is Active</Th>
              <Th whiteSpace="nowrap">Actions</Th>
              <Th whiteSpace="nowrap">Method</Th>
              {values &&
                values.triggers.some(
                  (trigger: any) => trigger.action.value === "url"
                ) && <Th whiteSpace="nowrap">Authenticate</Th>}
              {values &&
                values.triggers.some(
                  (trigger: any) =>
                    trigger.action.value === "url" &&
                    trigger.authenticate === true
                ) && <Th whiteSpace="nowrap">Authentication Type</Th>}
              {values &&
                values.triggers.some(
                  (trigger: any) =>
                    trigger.action.value === "url" &&
                    trigger.authenticate === true &&
                    trigger.authType.value === "credential"
                ) && (
                  <>
                    <Th whiteSpace="nowrap">Username</Th>
                    <Th whiteSpace="nowrap">Password</Th>
                  </>
                )}
              {values &&
                values.triggers.some(
                  (trigger: any) =>
                    trigger.action.value === "url" &&
                    trigger.authenticate === true &&
                    trigger.authType.value === "jwt"
                ) && (
                  <>
                    <Th whiteSpace="nowrap">Token</Th>
                  </>
                )}
              <Th></Th>
            </Tr>
          </Thead>
          <FieldArray name="triggers">
            {({ remove }) => (
              <TableLoader show={values.triggers.length} loader={false}>
                <Tbody>
                  {values.triggers.map((trigger: any, index: any) => (
                    <Tr key={index}>
                      <Td>
                        <Box w={{ base: "320px", lg: "220px" }}>
                          <CustomInput
                            type="select"
                            name={`triggers[${index}].approval`}
                            value={trigger.approval}
                            placeholder="Select Approval"
                            options={triggerApprovals}
                            onChange={(e: any) =>
                              setFieldValue(`triggers[${index}].approval`, e)
                            }
                            rest={{ minWidth: "130px" }}
                            disabled={isDisabled}
                            isBoxSelect={true}
                            isMulti
                          />
                        </Box>
                      </Td>
                      <Td>
                        <Box w={{ base: "320px", lg: "220px" }}>
                          <CustomInput
                            type="select"
                            name={`triggers[${index}].level`}
                            value={trigger?.level}
                            placeholder="Select Level"
                            // label="Select Active Mode"
                            options={generateLevels(values.levels)}
                            onChange={(e: any) =>
                              setFieldValue(`triggers[${index}].level`, e)
                            }
                            rest={{ minWidth: "130px" }}
                            disabled={isDisabled}
                            isBoxSelect={true}
                            isMulti
                          />
                        </Box>
                      </Td>
                      <Td>
                        <Box w={{ base: "320px", lg: "130px" }}>
                          <CustomInput
                            type="select"
                            name={`triggers[${index}].isActive`}
                            value={trigger?.isActive || ""}
                            placeholder="Active Trigger"
                            options={isActivetrigger}
                            onChange={(e) =>
                              setFieldValue(`triggers[${index}].isActive`, e)
                            }
                            rest={{ minWidth: "130px" }}
                            disabled={isDisabled}
                            isBoxSelect={true}
                          />
                        </Box>
                      </Td>
                      <Td>
                        <Box w={{ base: "320px", lg: "130px" }}>
                          <CustomInput
                            type="select"
                            name={`triggers[${index}].action`}
                            value={trigger.action}
                            placeholder="Select Action"
                            options={triggerActions}
                            onChange={(e: any) => {
                              console.log(e);
                              setFieldValue(`triggers[${index}].action`, e);
                              setFieldValue(`triggers[${index}].method`, "");
                            }}
                            rest={{ minWidth: "130px" }}
                            disabled={isDisabled}
                            isBoxSelect={true}
                          />
                        </Box>
                      </Td>
                      <Td>
                        <Box w={{ base: "320px", lg: "280px" }}>
                          {trigger?.action?.value ===
                          triggerActions[0].value ? (
                            <CustomInput
                              type="text"
                              name={`triggers[${index}].method`}
                              value={trigger.method}
                              placeholder="Please Enter Url"
                              onChange={(e: any) =>
                                setFieldValue(
                                  `triggers[${index}].method`,
                                  e.target.value
                                )
                              }
                              rest={{ minWidth: "280px" }}
                              disabled={isDisabled}
                            />
                          ) : (
                            <CustomInput
                              type="text"
                              name={`triggers[${index}].method`}
                              value={trigger.method}
                              placeholder="Enter emails (comma-separated)"
                              onChange={(e: any) =>
                                setFieldValue(
                                  `triggers[${index}].method`,
                                  e.target.value
                                )
                              }
                              rest={{ minWidth: "280px" }}
                              disabled={isDisabled}
                            />
                          )}
                        </Box>
                      </Td>
                      {values &&
                        values.triggers.some(
                          (trigger: any) => trigger.action.value === "url"
                        ) && (
                          <Td w={{ base: "320px", lg: "280px" }}>
                            <CustomInput
                              disabled={isDisabled}
                              type="switch"
                              // label="View"
                              name={`triggers[${index}].authenticate`}
                              value={trigger.authenticate}
                              onChange={(e: any) =>
                                setFieldValue(
                                  `triggers[${index}].authenticate`,
                                  e.target.checked
                                )
                              }
                            />
                          </Td>
                        )}
                      {values &&
                        values.triggers.some(
                          (trigger: any) =>
                            trigger.action.value === "url" &&
                            trigger.authenticate === true
                        ) && (
                          <Td w={{ base: "320px", lg: "280px" }}>
                            <CustomInput
                              type="select"
                              name={`triggers[${index}].authType`}
                              value={trigger.authType}
                              placeholder="Select Type"
                              options={authenticateType}
                              onChange={(e: any) => {
                                console.log(e);
                                setFieldValue(`triggers[${index}].authType`, e);
                              }}
                              rest={{ minWidth: "180px" }}
                              disabled={isDisabled}
                              isBoxSelect={true}
                            />
                          </Td>
                        )}
                      {values &&
                        values.triggers.some(
                          (trigger: any) =>
                            trigger.action.value === "url" &&
                            trigger.authenticate === true &&
                            trigger.authType.value === "credential"
                        ) && (
                          <>
                            <Td w={{ base: "320px", lg: "280px" }}>
                              <CustomInput
                                name={`triggers[${index}].userName`}
                                value={trigger.userName}
                                onChange={(e: any) =>
                                  setFieldValue(
                                    `triggers[${index}].userName`,
                                    e.target.value
                                  )
                                }
                                placeholder="Enter username"
                                disabled={isDisabled}
                                rest={{ minWidth: "180px" }}
                              />
                            </Td>
                            <Td w={{ base: "320px", lg: "280px" }}>
                              <CustomInput
                                name={`triggers[${index}].password`}
                                type="password"
                                value={trigger.password}
                                onChange={(e: any) =>
                                  setFieldValue(
                                    `triggers[${index}].password`,
                                    e.target.value
                                  )
                                }
                                placeholder="Enter password"
                                disabled={isDisabled}
                                rest={{ minWidth: "180px" }}
                              />
                            </Td>
                          </>
                        )}
                      {values &&
                        values.triggers.some(
                          (trigger: any) =>
                            trigger.action.value === "url" &&
                            trigger.authenticate === true &&
                            trigger.authType.value === "jwt"
                        ) && (
                          <Td w={{ base: "320px", lg: "280px" }}>
                            <CustomInput
                              name={`triggers[${index}].token`}
                              value={trigger.token}
                              onChange={(e: any) =>
                                setFieldValue(
                                  `triggers[${index}].token`,
                                  e.target.value
                                )
                              }
                              placeholder="Enter token"
                              disabled={isDisabled}
                              rest={{ minWidth: "180px" }}
                            />
                          </Td>
                        )}
                      <Td>
                        <Flex>
                          <Tooltip
                            label="Delete trigger"
                            hasArrow
                            placement="left"
                          >
                            <Button
                              type="button"
                              mt="8px"
                              colorScheme="red"
                              variant="outline"
                              // size="sm"
                              onClick={() => remove(index)}
                              h="38px"
                              isDisabled={isDisabled}
                            >
                              <DeleteIcon />
                            </Button>
                          </Tooltip>
                          {index === values.triggers.length - 1 && (
                            <Tooltip
                              label="Add trigger"
                              hasArrow
                              placement="left"
                            >
                              <Button
                                bg="teal.400"
                                color="white"
                                _hover={{ bg: "teal.500" }}
                                ml={5}
                                h="38px"
                                mt="8px"
                                onClick={() => {
                                  setFieldValue("triggers", [
                                    ...values.triggers,
                                    {
                                      approval: triggerApprovals,
                                      level: generateLevels(3),
                                      isActive: isActivetrigger[0],
                                      action: triggerActions[0],
                                      method: undefined,
                                      authenticate: true,
                                      authType: authenticateType[0],
                                      userName: "",
                                      password: "",
                                      token: "",
                                    },
                                  ]);
                                }}
                                isDisabled={isDisabled}
                              >
                                <FaPlus />
                              </Button>
                            </Tooltip>
                          )}
                        </Flex>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </TableLoader>
            )}
          </FieldArray>
        </Table>
      </Box> */}
    </Box>
  );
};

export default TriggerForm;
